import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/posts/[location]/ClientPage.tsx");
